
import Vue from "vue";
import ListItem from './ListItem.vue'
import { INode } from "@/shared/models/node.model";
import { HtmlHelper } from "@/shared/lib/htmlhelper";

export default Vue.extend({
  name: "MenuTree",
  props: {
    startNodeId: Number,
    chapter: Object as () => INode,
    mobileMenuOpen: Boolean,
  },
  components: {
    ListItem
  },
  data() {
    return {
      activeNodeId: 0 as number,
      isMobileMenuOpen: false as boolean,
      isMenuButtonHidden: false as boolean,
    };
  },

  mounted() {
    this.activeNodeId = this.startNodeId;
    this.isMobileMenuOpen = this.mobileMenuOpen;
  },

  watch: {
    startNodeId(value: number) {
      if (value > 0) {
        this.activeNodeId = value;
      }
    }
  },
  methods: {
    showItem(selectedItem: INode, chapter: INode) {
      this.$emit("show-item", selectedItem, chapter);
      this.activeNodeId = selectedItem.Id;
      if (this.isMobileMenuOpen) {
        this.toggleMenu();
      }
    },

    toggleMenu(): void {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
      this.isMenuButtonHidden = !this.isMenuButtonHidden;
      if (this.isMobileMenuOpen) {
        document.documentElement.classList.add("no-scroll");
      } else {
        document.documentElement.classList.remove("no-scroll");
      }
    },
    getStartPage(): string {
      const helper = new HtmlHelper();
      return helper.getBaseUrl();
    },
    openChapterPage(): void {
      this.activeNodeId = -1;
      this.$emit("show-tree", this.chapter);
    }
  },
});
